import { css, jsx } from '@emotion/react';
import { daysFromNow, parseDateTime } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { Price } from '@zapier/currency';
import { useUniversalNavContext } from '../../../../universal-nav/hooks';
import { labelStyles } from '@zapier/style-encapsulation';
import { baseReset } from '../../../../utils/style-mixins/reset';
export const shouldRender = (data) => {
    const { currentAccount } = data;
    return (currentAccount.isTrialingCompanies &&
        currentAccount.companiesTrialEndDate &&
        currentAccount.currentUserRole &&
        ['owner', 'admin', 'super_admin'].includes(currentAccount.currentUserRole));
};
const Styles = labelStyles('CompaniesTrialing', {
    content: css `
    ${baseReset};
  `,
});
export const Component = function CompaniesTrialing(props) {
    var _a, _b, _c, _d;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { data, currency } = props;
    const { currentAccount } = data;
    const { companiesTrialEndDate, companiesTrialAutoUpgrade: willAutoUpgrade } = currentAccount;
    const trialDaysRemaining = daysFromNow(companiesTrialEndDate);
    const daysText = trialDaysRemaining === 1 ? 'day' : 'days';
    const title = `${trialDaysRemaining} ${daysText} left in your Company trial`;
    const nextPlanAmount = (((_a = data.nextCompanyPlan) === null || _a === void 0 ? void 0 : _a.amount) || 0) / 12;
    const formattedEndDate = parseDateTime(companiesTrialEndDate)
        .toLocaleString('en-US', { month: 'short', day: 'numeric' })
        .replace(/([a-z]+)/i, '$1.');
    const autoBillingLink = (jsx(Link, { href: getFullyQualifiedURL('/app/settings/billing') }, "Edit trial payment settings"));
    const content = willAutoUpgrade ? (jsx("p", { "data-zds": true, css: Styles.content },
        `You will be billed and charged `,
        jsx(Price, { currency: currency }, nextPlanAmount),
        "/month ",
        ' at the end of your trial. ',
        autoBillingLink)) : (jsx("p", { "data-zds": true, css: Styles.content },
        `On ${formattedEndDate}, you’ll lose access to Company plan features and be downgraded to a ${(_d = (_c = (_b = data.currentAccount) === null || _b === void 0 ? void 0 : _b.plan) === null || _c === void 0 ? void 0 : _c.type) !== null && _d !== void 0 ? _d : 'Free'} plan. `,
        autoBillingLink));
    return (jsx(Alert, { variant: props.variant, title: title, status: "info" }, content));
};
//# sourceMappingURL=CompaniesTrialing.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
